var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGanttListRefreshNew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3033_2962)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.6666 8.00016C14.6666 11.682 11.6818 14.6668 7.99998 14.6668C4.31808 14.6668 1.33331 11.682 1.33331 8.00016C1.33331 4.31826 4.31808 1.3335 7.99998 1.3335C10.181 1.3335 12.1175 2.3809 13.3338 4.00016V1.3335",
    stroke: "#505363",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3033_2962"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGanttListRefreshNew);
export default __webpack_public_path__ + "static/media/gantt-list-refresh-new.c83ce87e33de64ab821b583997f88f2e.svg";
export { ForwardRef as ReactComponent };